import { useEffect } from 'react';
import { ArrowHeadIcon } from '@integration/alexandria-ui';
import { useHistory } from 'react-router-dom';
import {
  Container,
  ImageContainer,
  Title,
  BackButtonContainer,
  BackButtonText,
  MarkdownContainer,
} from './NotFoundStyled';
import { event } from 'analytics';
import { useNotFound } from './notFoundHook';
import { useTranslate } from 'hooks/translation-hooks';
import { addGtmPageView as pageview } from 'redux/actions/gtmActions';
import { useDispatch } from 'react-redux';
import Markdown from 'components/Markdown';

export const NotFound = () => {
  const t = useTranslate();
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClick = () => {
    event('back', 'not_found_page');
    history.goBack();
  };
  useEffect(() => {
    dispatch(pageview('/not-found'));
  }, [dispatch]);
  const { themeData } = useNotFound();
  return (
    <Container>
      <ImageContainer />
      <Title>{t('not_found-title')}</Title>
      <MarkdownContainer>
        <Markdown text={t('not_found-content')} />
      </MarkdownContainer>
      <BackButtonContainer onClick={handleClick}>
        <ArrowHeadIcon width={17} height={16} color={themeData.primaryColor} />
        <BackButtonText>{t('not_found-back')}</BackButtonText>
      </BackButtonContainer>
    </Container>
  );
};

export default NotFound;
